export const OPREMA_V1ResourcesDE: OPREMA_V1ResourcesBSInterface = {
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  input: {
    datum: {
      name: "datum",
      label: "Datum der Aufgabenerledigung",
      placeholder: "Datum eingeben",
    },
    tip: {
      name: "tip",
      label: "Bitte geben Sie den Typ ein",
      placeholder: "Typ eingeben",
    },
    izvrsioc: {
      name: "izvrsioc",
      label: "Bitte geben Sie den Ausführenden ein",
      placeholder: "Ausführenden eingeben",
    },
    opis: {
      name: "opis",
      label: "Bitte geben Sie eine Beschreibung ein",
      placeholder: "Beschreibung eingeben",
    },
  },
  type: {
    EvdLabel: "Evidenztyp",
    Name: "type",
    Placeholder:
      "Eingeben: Regelmäßig, außerordentlich, allgemein, wöchentlich, monatlich, jährlich...",
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
};

interface InputField {
  name: string;
  label: string;
  placeholder: string;
}

interface Input {
  datum: InputField;
  tip: InputField;
  izvrsioc: InputField;
  opis: InputField;
}

interface Type {
  EvdLabel: string;
  Name: string;
  Placeholder: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface OPREMA_V1ResourcesBSInterface {
  input: Input;
  type: Type;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
